import { render, staticRenderFns } from "./firma-individual-formalizacion-becas.vue?vue&type=template&id=65c705aa&scoped=true&"
import script from "./firma-individual-formalizacion-becas.component.ts?vue&type=script&lang=ts&"
export * from "./firma-individual-formalizacion-becas.component.ts?vue&type=script&lang=ts&"
import style0 from "./firma-individual-formalizacion-becas.vue?vue&type=style&index=0&id=65c705aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c705aa",
  null
  
)

export default component.exports